import { Loader } from "@itandi/itandi-bb-ui/Loader";
import { Page as Component } from "~/components/specifics/Page";
import { useCompanyStoreSettings } from "~/hooks/useCompanyStoreSettings";
import type { ItandiAccount } from "~/models/ItandiAccount";

type Props = {
	account: ItandiAccount;
};

export function Page({ account }: Props) {
	const { data: companyStoreSettings } = useCompanyStoreSettings().index();

	if (account.store !== null && companyStoreSettings !== null) {
		return (
			<Component
				companyStoreSettings={companyStoreSettings}
				currentAccount={account}
				currentStore={account.store}
			/>
		);
	}

	return <Loader />;
}
